import { action, createRequestTypes } from '../base';

export const currenciesActionTypes = {
  GET_CURRENCIES: createRequestTypes('GET_CURRENCIES'),
  CREATE_CURRENCIES: createRequestTypes('CREATE_CURRENCIES'),
  UPDATE_CURRENCIES: createRequestTypes('UPDATE_CURRENCIES'),
  DELETE_CURRENCIES: createRequestTypes('DELETE_CURRENCIES'),
  GET_CURRENCY_CONVERSION_RATE: createRequestTypes('GET_CURRENCY_CONVERSION_RATE'),
  REFRESH_CURRENCY_CONVERSION_RATE: createRequestTypes('REFRESH_CURRENCY_CONVERSION_RATE'),
};

/*
 *
 * @param payload
 * @param orgId
 * @param callback
 */
class CurrenciesActions {
    createCurrencies = (payload, callback) => action(currenciesActionTypes.CREATE_CURRENCIES.REQUEST, {
      payload,
      callback,
    });

    createCurrenciesLoading = (createCurrenciesLoading) => action(currenciesActionTypes.CREATE_CURRENCIES.LOADING, {
      createCurrenciesLoading,
    })

     updateCurrencies = (payload, callback) => action(currenciesActionTypes.UPDATE_CURRENCIES.REQUEST, {
       payload,
       callback,
     });

    updateCurrenciesLoading = (updateCurrenciesLoading) => action(currenciesActionTypes.UPDATE_CURRENCIES.LOADING, {
      updateCurrenciesLoading,
    })

    /**
     *
     * @param payload
     * @param callback
     */
    getCurrencies = (orgId, callback) => action(currenciesActionTypes.GET_CURRENCIES.REQUEST, {
      orgId, callback,
    })

    /**
     *
     * @return
     */
    getCurrenciesLoading = (getCurrenciesLoading) => action(currenciesActionTypes.GET_CURRENCIES.LOADING, {
      getCurrenciesLoading,
    })

    /**
     * @return
     */
    getCurrenciesSuccess = (CurrenciesResults) => action(currenciesActionTypes.GET_CURRENCIES.SUCCESS, {
      CurrenciesResults,
    })

    deleteCurrencies = (payload, callback) => action(currenciesActionTypes.DELETE_CURRENCIES.REQUEST, {
      payload,
      callback,
    });

    /**
     *
     * @return
     */
    deleteCurrenciesLoading = (deleteCurrenciesLoading) => action(currenciesActionTypes.DELETE_CURRENCIES.LOADING, {
      deleteCurrenciesLoading,
    })

    getCurrencyConversionRate = (payload, callback) => action(currenciesActionTypes.GET_CURRENCY_CONVERSION_RATE.REQUEST, {
      payload, callback,
    })

    getCurrencyConversionRateLoading = (getCurrencyConversionRateLoading) => action(currenciesActionTypes.GET_CURRENCY_CONVERSION_RATE.LOADING, {
      getCurrencyConversionRateLoading,
    })

    getCurrencyConversionRateSuccess = (currencyConversionRateResults) => action(currenciesActionTypes.GET_CURRENCY_CONVERSION_RATE.SUCCESS, {
      currencyConversionRateResults,
    })

    refreshCurrencyConversionRate = (payload, callback) => action(currenciesActionTypes.REFRESH_CURRENCY_CONVERSION_RATE.REQUEST, {
      payload, callback,
    })

    refreshCurrencyConversionRateLoading = (refreshCurrencyConversionRateLoading) => action(currenciesActionTypes.REFRESH_CURRENCY_CONVERSION_RATE.LOADING, {
      refreshCurrencyConversionRateLoading,
    })
}
export default new CurrenciesActions();
